import { motion } from 'framer-motion';
import type { MonthlyAssessment } from '../../lib/partner-dashboard';

interface AssessmentsOverTimeProps {
  data: MonthlyAssessment[];
  locale?: string;
}

export function AssessmentsOverTime({ data, locale }: AssessmentsOverTimeProps) {
  const tr = locale === 'tr';
  const maxCount = Math.max(...data.map(d => d.count), 1);

  const totalThisPeriod = data.reduce((sum, d) => sum + d.count, 0);

  return (
    <div className="freud-card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-text-xl text-gray-80">{tr ? 'Zaman Icinde Degerlendirmeler' : 'Assessments Over Time'}</h3>
        <span className="text-text-sm text-gray-40">
          {tr ? `${totalThisPeriod} toplam (6 ay)` : `${totalThisPeriod} total (6 months)`}
        </span>
      </div>

      {totalThisPeriod === 0 ? (
        <p className="text-text-sm text-gray-40 text-center py-8">
          {tr ? 'Son 6 ayda tamamlanan degerlendirme yok' : 'No assessments completed in the last 6 months'}
        </p>
      ) : (
        <div className="flex items-end gap-3 h-40">
          {data.map((month, index) => (
            <div key={month.month} className="flex-1 flex flex-col items-center gap-2">
              <span className="text-text-xs text-gray-50 font-medium">
                {month.count > 0 ? month.count : ''}
              </span>
              <motion.div
                className="w-full bg-success-40 rounded-t-md min-h-[4px]"
                initial={{ height: 4 }}
                animate={{
                  height: month.count > 0
                    ? `${Math.max((month.count / maxCount) * 120, 8)}px`
                    : '4px',
                }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                style={{
                  opacity: month.count > 0 ? 1 : 0.25,
                }}
              />
              <span className="text-text-xs text-gray-40">{month.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
